// extracted by mini-css-extract-plugin
export default {"pages":"list_pages__C9gG9","on":"list_on__dkROw","posts":"list_posts__3EhK0","paginationNumbers":"list_paginationNumbers__+YW2K"};